import { Stack, TextField, Typography } from '@mui/material';
import { ICaseDetailsInputs } from 'API';
import { CustomRadioGroup, FileUpload, RadioButtons } from 'Components';
import { yesNoOptions } from 'Constants';
import { Dictionary } from 'Dictionary';
import { DICTIONARY, FileCategories } from 'Enum';
import { useAppSelector, useDictionary } from 'Hooks';
import { IndexContext } from 'Modules/CaseDetails/CaseContext';
import { useContext } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { generateError } from 'Regex';
import { styleTextField } from 'Theme';
import { validateLettersAndNumbersOnly } from 'Utils/validateLettersAndNumbersOnly';
import { WAS_DRIVER_DURING_ACCIDENT_ID } from '../WhatDidDoDuringAccident';

export const TRAFFIC_ACCIDENT_NO_INSURANCE_SUE_ID = 4;

export const Insurance = () => {
  const { index, fieldId } = useContext(IndexContext);

  const {
    register,
    formState: { errors },
  } = useFormContext<ICaseDetailsInputs>();

  const [compensationClaimSentOptions] = useAppSelector(
    ({
      generalContent: {
        generalContent: { compensationClaimSentOptions },
      },
    }) => [compensationClaimSentOptions]
  );

  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  const baseName = `caseDetails.${index}.trafficAccidentSection`;

  const [
    isVehicleInsuranceExist,
    compensationClaimSentOptionId,
    whatHaveYouDoDuringAccidentOptionId,
  ] = useWatch({
    name: [
      `${baseName}.isVehicleInsuranceExist`,
      `${baseName}.compensationClaimSentOptionId`,
      `${baseName}.whatHaveYouDoDuringAccidentOptionId`,
    ],
  });

  const trafficAccidentError = errors.caseDetails
    ? errors.caseDetails[index]?.trafficAccidentSection
    : undefined;

  return (
    <>
      {whatHaveYouDoDuringAccidentOptionId == WAS_DRIVER_DURING_ACCIDENT_ID && (
        <RadioButtons
          id={dictionary.thirdSectionInputInsuranceQ}
          name={`${baseName}.isVehicleInsuranceExist` as const}
          options={yesNoOptions}
        />
      )}
      {isVehicleInsuranceExist && (
        <Stack gap='7px'>
          <Typography>{dictionary.thirdSectionInputInsurance}</Typography>
          <FileUpload
            caseDetailsId={fieldId}
            fileLabel={dictionary.thirdSectionSecondFileUploadText}
            fileCategoryId={FileCategories.VehicleInsurance}
            ariaLabel={dictionary.thirdSectionSecondFileUploadLabel}
          />
        </Stack>
      )}
      <CustomRadioGroup
        id={dictionary.thirdSectionInsuranceSueQ}
        name={`${baseName}.compensationClaimSentOptionId` as const}
        options={compensationClaimSentOptions.map(({ id, value }) => ({
          value: id.toString(),
          label: value,
        }))}
      />
      {compensationClaimSentOptionId !== null &&
        compensationClaimSentOptionId !=
          TRAFFIC_ACCIDENT_NO_INSURANCE_SUE_ID && (
          <>
            <TextField
              inputProps={{
                maxLength: '50',
              }}
              id={`${dictionary.thirdSectionThirdInputValue}-${index}`}
              {...register(
                `${baseName}.insuranceCompany` as `caseDetails.0.trafficAccidentSection.insuranceCompany`
              )}
              label={dictionary.thirdSectionThirdInputValue}
              onChange={(event: any) => validateLettersAndNumbersOnly(event)}
              sx={styleTextField}
              role={
                Boolean(trafficAccidentError?.insuranceCompany)
                  ? 'alert'
                  : undefined
              }
              error={Boolean(trafficAccidentError?.insuranceCompany)}
              helperText={
                Boolean(trafficAccidentError?.insuranceCompany?.message) &&
                generateError(
                  dictionary.thirdSectionThirdInputValue,
                  trafficAccidentError?.insuranceCompany?.message!
                )
              }
            />
            <Stack gap='7px'>
              <Typography>{dictionary.thirdSectionInsuranceSueFile}</Typography>
              <FileUpload
                caseDetailsId={fieldId}
                fileLabel={dictionary.thirdSectionInsuranceSueFileLabel}
                fileCategoryId={FileCategories.CompensationClaim}
                ariaLabel={dictionary.thirdSectionInsuranceSueFile}
              />
            </Stack>
          </>
        )}
    </>
  );
};
